// FE-084 — l'archivio documenti si sfoglia a blocchi («Carica altri»).
//
// Logica pura, senza React: la provano `archivioBlocchi.test.js` (jest) e la
// usano l'hook `useArchivioBlocchi.js` e il PDF del cantiere. Fino al 27/09
// ogni vista leggeva SOLO il primo blocco da 20 e taceva sul resto: una
// cartella con 25 foto ne mostrava 20, senza pulsante ne' contatore.

// Quanti documenti per blocco (decisione di Vale, 27/09).
export const BLOCCO_DOCUMENTI = 50;

// Unisce un blocco nuovo a quelli gia' caricati, senza doppioni: se fra un
// clic e l'altro qualcuno carica un documento, l'ultimo del blocco precedente
// scivola nel successivo e arriverebbe due volte.
export function unisciBlocchi(caricati, nuovi) {
  var visti = {};
  var risultato = [];
  (caricati || []).concat(nuovi || []).forEach(function (doc) {
    if (!doc || visti[doc.id]) return;
    visti[doc.id] = true;
    risultato.push(doc);
  });
  return risultato;
}

// Quale pagina chiedere per il blocco successivo. Si ricava da QUANTI documenti
// ci sono gia', non da un contatore di pagine: se l'artigiano ne elimina uno, le
// pagine del server scalano di un posto e «pagina + 1» ne salterebbe uno. Cosi'
// si richiede la pagina che lo contiene, e i doppioni li toglie `unisciBlocchi`.
export function paginaSuccessiva(caricati, blocco) {
  return Math.floor(caricati / blocco) + 1;
}

export function ciSonoAltri(caricati, totale) {
  return typeof totale === 'number' && caricati < totale;
}

export function testoContatore(caricati, totale) {
  return 'Mostrati ' + caricati + ' di ' + totale;
}

// Stellina: prima la scelta appena fatta dall'artigiano (in memoria), poi il
// campo `preferito` che il server calcola per ogni documento.
export function statoPreferito(doc, preferitiLocali) {
  if (!doc) return false;
  if (preferitiLocali && Object.prototype.hasOwnProperty.call(preferitiLocali, doc.id)) {
    return preferitiLocali[doc.id] === true;
  }
  return doc.preferito === true;
}

// FE-088 — il server manda in `documenti_count` il totale della cartella E di
// tutte le sue sottocartelle (`documenti/serializers.py`, get_documenti_count).
// Risommarlo per ogni sottocartella contava un documento una volta per livello.
export function conteggioCartella(cartella) {
  return (cartella && cartella.documenti_count) || 0;
}

// Tetto di sicurezza per `caricaTutteLePagine`: 100 pagine da 200 sono 20.000
// documenti. Oltre, un errore RUMOROSO (R54) invece di un elenco troncato in
// silenzio — che e' proprio il difetto di FE-084.
export const PAGINE_MASSIME = 100;

// Segue tutte le pagine (come il listino) per chi ha bisogno dell'elenco
// COMPLETO, per esempio un PDF. `chiedi(pagina)` restituisce la risposta
// dell'API (`{ data: { results, next } }`).
export async function caricaTutteLePagine(chiedi) {
  var tutti = [];
  for (var pagina = 1; pagina <= PAGINE_MASSIME; pagina++) {
    var risposta = await chiedi(pagina);
    var dati = (risposta && risposta.data) || {};
    var righe = Array.isArray(dati) ? dati : (dati.results || []);
    tutti = unisciBlocchi(tutti, righe);
    if (Array.isArray(dati) || !dati.next) return tutti;
  }
  throw new Error('Troppi documenti da caricare in una volta (oltre ' + PAGINE_MASSIME + ' pagine).');
}
